import React from 'react';
import SectionQuote from './SectionQuote';

function Coming() {
  return (
    <section className="coming section" aria-label="What's coming">
      <SectionQuote>Surrender now, or die in obscurity!</SectionQuote>
      <div className="prose">
        <p>
          Action platformers, tactical RPGs, top-down adventure, story-driven
          JRPGs. All original. All made with genuine love for what games used to
          be willing to attempt.
        </p>
        <p>
          If this sounds like huge scope for an indie developer - it is! 
          We're non-traditional, working in a way that works for us and
          not necessarily what gets the fastest delivery or most revenue,
          but instead produces the games that we truly love.
        </p>
      </div>
    </section>
  );
}

export default Coming;
